<template>
  <div>
    <page-header title="داشبورد" subtitle="نمای کلی آخرین فعالیت‌های سایت"></page-header>

    <v-row class="mb-2">
      <v-col cols="12" md="4" class="px-0 pl-md-3">
        <v-card class="settings-card fill-height mb-0">
          <v-card-title><v-icon left>mdi-currency-usd</v-icon>قیمت دلار</v-card-title>
          <v-card-subtitle>قیمت ریالی محصولات دلاری با این نرخ محاسبه می‌شود.</v-card-subtitle>
          <v-card-text>
            <v-text-field v-model="dollarPrice" label="قیمت دلار (ریال)" dir="ltr"
                          color="#00ADB5" outlined dense></v-text-field>
            <div class="form-actions">
              <v-btn class="btn-primary" depressed @click="updateDollarPrice">
                <v-icon left>mdi-content-save</v-icon>
                ثبت قیمت
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" class="px-0 pr-md-3">
        <v-card class="settings-card fill-height mb-0">
          <v-card-title><v-icon left>mdi-lightning-bolt</v-icon>دسترسی سریع</v-card-title>
          <v-card-text>
            <div class="quick-links">
              <router-link v-for="link in quickLinks" :key="link.to" :to="link.to" class="quick-link sunken-block">
                <v-icon color="#00ADB5">{{ link.icon }}</v-icon>
                <span>{{ link.title }}</span>
              </router-link>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="settings-card" v-for="section in sections" :key="section.title">
      <v-card-title>
        <v-icon left>{{ section.icon }}</v-icon>{{ section.title }}
        <v-spacer></v-spacer>
        <router-link v-if="section.to" :to="section.to" class="see-all">
          مشاهده همه
          <v-icon small color="#00ADB5">mdi-arrow-left</v-icon>
        </router-link>
      </v-card-title>
      <v-card-text>
        <table-with-out-pagination v-if="section.items"
                                   :items="section.items"
                                   :headers="section.headers"
        ></table-with-out-pagination>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TableWithOutPagination from "@/components/General/TableWithOutPagination.vue";
import PageHeader from "@/components/General/PageHeader.vue";

export default {
  name: 'HomeView',
  components: {TableWithOutPagination, PageHeader},

  data() {
    return {
      comments: [],
      messages: [],
      customers: [],
      orders: [],
      dollarPrice: 0,
      quickLinks: [
        {title: 'محصول جدید', icon: 'mdi-toolbox', to: '/products/create'},
        {title: 'پست جدید', icon: 'mdi-note-plus', to: '/posts/create'},
        {title: 'سفارشات', icon: 'mdi-shopping', to: '/orders'},
        {title: 'پیام‌ها', icon: 'mdi-email', to: '/messages'},
        {title: 'دسته‌بندی‌ها', icon: 'mdi-shape', to: '/categories'},
        {title: 'صفحه اصلی سایت', icon: 'mdi-home', to: '/settings/home_page'},
      ],

      commentsHeaders: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'کامنت', value: 'comment', align: 'center'},
        {text: 'جواب', value: 'admin_reply', align: 'center'},
        {text: 'کاربر نویسنده', value: 'customer', align: 'center'},
        {text: 'مدیر جواب دهنده', value: 'admin', align: 'center'},
        {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
        {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
      ],

      messagesHeaders: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'پیام', value: 'message', align: 'center'},
        {text: 'جواب', value: 'admin_reply', align: 'center'},
        {text: 'کاربر نویسنده', value: 'customer', align: 'center'},
        {text: 'مدیر جواب دهنده', value: 'admin', align: 'center'},
        {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
        {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
      ],

      customersHeaders: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'شماره موبایل', value: 'phone_number', align: 'center'},
        {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
        {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
      ],

      ordersHeaders: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'مشتری', value: 'customer', align: 'center'},
        {text: 'وضعیت', value: 'status_name', align: 'center'},
        {text: 'یادداشت', value: 'note', align: 'center'},
        {text: 'صورتحساب', value: 'invoice_url', align: 'center'},
        {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
        {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
      ],
    }
  },

  computed: {
    sections() {
      return [
        {title: 'آخرین سفارشات', icon: 'mdi-shopping', to: '/orders', items: this.orders, headers: this.ordersHeaders},
        {title: 'آخرین پیام‌ها', icon: 'mdi-email', to: '/messages', items: this.messages, headers: this.messagesHeaders},
        {title: 'آخرین نظرات', icon: 'mdi-comment-text', to: null, items: this.comments, headers: this.commentsHeaders},
        {title: 'آخرین کاربران', icon: 'mdi-account-group-outline', to: '/customers', items: this.customers, headers: this.customersHeaders},
      ]
    },
  },

  mounted() {
    this.getDashboardData()
  },

  methods: {
    getDashboardData() {
      this.$store.dispatch("getDashboardData").then((res) => {
        this.comments = res.data.comments
        this.messages = res.data.messages
        this.customers = res.data.customers
        this.orders = res.data.orders
        this.dollarPrice = res.data.dollor_price.en_value
      })
    },

    updateDollarPrice() {
      this.$store.dispatch("updateDollarPrice", this.dollarPrice)
    },
  }
}
</script>

<style scoped>
.quick-links {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.quick-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  text-decoration: none;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.quick-link:hover {
  border-color: rgba(0, 173, 181, 0.6);
  background: rgba(0, 173, 181, 0.08);
}

.see-all {
  font-size: 14px;
  text-decoration: none;
  color: #00ADB5 !important;
}

@media (max-width: 960px) {
  .quick-links {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
